<let/count=$global.visitorCount || 0>

<lifecycle
  onMount() {
    // Defer off the critical path: the counter is cosmetic and shouldn't
    // compete with hydration or LCP-critical work.
    const report = () => {
      const storedFirstVisit = localStorage.getItem("firstVisit") || "true";

      fetch("/api/updateVisitorCount", {
        method: storedFirstVisit === "true" ? "POST" : "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("HTTP error! status: " + response.status);
          }
          return response.json();
        })
        .then((data) => {
          localStorage.setItem("firstVisit", "false");
          count = data.count;
        })
        .catch((error) => {
          console.error("Error fetching visitor count:", error);
        });
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(report, { timeout: 4000 });
    } else {
      setTimeout(report, 1500);
    }
  }
/>

<div class="label text-c-400 flex items-center gap-3">
  Visitors
  <span class="readout bg-screen border border-rule px-2 py-1 text-[var(--role-kits)]">${count ? String(count).padStart(6, "0") : "------"}</span>
</div>
